package pwgs.ui.scenes.projectrootscene

import pwgs.ui.scenes.allowedversionsscene.AllowedVersionsScene
import pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneProps
import pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardScene
import pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneProps
import pwgs.ui.scenes.customstatscene.CustomStatScene
import pwgs.ui.scenes.customstatscene.CustomStatSceneProps
import pwgs.ui.scenes.diagnosticserrorgroupsscene.DiagnosticsErrorGroupsScene
import pwgs.ui.scenes.diagnosticserrorgroupsscene.DiagnosticsErrorGroupsSceneProps
import pwgs.ui.scenes.diagnosticsissuelistscene.DiagnosticsIssueListScene
import pwgs.ui.scenes.diagnosticsissuelistscene.DiagnosticsIssueListSceneProps
import pwgs.ui.scenes.leaderboardlistscene.LeaderboardListScene
import pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneProps
import pwgs.ui.scenes.playerconfigscene.PlayerConfigScene
import pwgs.ui.scenes.playerscene.PlayerSceneProps
import pwgs.ui.scenes.playerscene.PlayerSceneScene
import pwgs.ui.scenes.playerslistscene.PlayersListScene
import pwgs.ui.scenes.playerslistscene.PlayersListSceneProps
import pwgs.ui.scenes.remoteconfigscene.RemoteConfigScene
import pwgs.ui.scenes.settingsscene.SettingsScene
import pwgs.ui.scenes.userreportsscene.UserReportsScene
import pwgs.ui.scenes.userreportsscene.UserReportsSceneProps
import visage.core.*
import visage.ds.components.page.*

class MProjectRootScene(props: ProjectRootSceneProps) : AScene<ProjectRootSceneProps, ProjectRootSceneModel, ProjectRootSceneState, ProjectRootControllerFe>(props) {

    override fun createController() : ProjectRootControllerFe {
        return ProjectRootControllerFe(props, this)
    }

    override fun initState() : ProjectRootSceneState {
        return ProjectRootSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val m = this@MProjectRootScene.model
        if (m.isLoading) {
            +"Loading..."
            return
        }

        if (!m.hasPermission) {
            +"You don't have permission to view this page!"
            return
        }

        console.log("Rendering Application")
        Application {
            menu {
                items {
                    menuItem("Dashboard", "dashboard", "/app/project/${this@MProjectRootScene.props.projectId}/index.vsg")
                    groupMenuItem("Analytics", "monitoring", "/app/project/${this@MProjectRootScene.props.projectId}/analytics/") {
                        menuItem("Players", "/app/project/${this@MProjectRootScene.props.projectId}/analytics/players.vsg")
                        menuItem("New Players", "/app/project/${this@MProjectRootScene.props.projectId}/analytics/newPlayers.vsg")
                        menuItem("Revenue", "/app/project/${this@MProjectRootScene.props.projectId}/analytics/revenue.vsg")
                        menuItem("Trial users", "/app/project/${this@MProjectRootScene.props.projectId}/analytics/trialUsers.vsg")
                        menuItem("Platforms", "/app/project/${this@MProjectRootScene.props.projectId}/analytics/platforms.vsg")
                        menuItem("Activity", "/app/project/${this@MProjectRootScene.props.projectId}/analytics/activity.vsg")
                    }
                    groupMenuItem("Players", "person", "/app/project/${this@MProjectRootScene.props.projectId}/players/") {
                        menuItem("Browse", "/app/project/${this@MProjectRootScene.props.projectId}/players/browse.vsg")
                        menuItem("Configuration", "/app/project/${this@MProjectRootScene.props.projectId}/players/config.vsg")
                    }
                    menuItem("Remote Config", "sync", "/app/project/${this@MProjectRootScene.props.projectId}/remoteConfig.vsg")
                    menuItem("Economy", "attach_money", "/app/project/${this@MProjectRootScene.props.projectId}/economy/index.vsg")
                    menuItem("Inventory", "inventory", "/app/project/${this@MProjectRootScene.props.projectId}/inventory/index.vsg")
                    menuItem("Leaderboards", "leaderboard", "/app/project/${this@MProjectRootScene.props.projectId}/leaderboards/index.vsg")
                    menuItem("Achievements", "military_tech", "/app/project/${this@MProjectRootScene.props.projectId}/achievements/index.vsg")
                    menuItem("Allowed Versions", "pin", "/app/project/${this@MProjectRootScene.props.projectId}/allowedVersions.vsg")
                    menuItem("User Reports", "report", "/app/project/${this@MProjectRootScene.props.projectId}/userReports.vsg")

                    groupMenuItem("Diagnostics", "bug_report", "/app/project/${this@MProjectRootScene.props.projectId}/diagnostics/") {
                        menuItem("New issues", "/app/project/${this@MProjectRootScene.props.projectId}/diagnostics/new.vsg")
                        menuItem("Active issues", "/app/project/${this@MProjectRootScene.props.projectId}/diagnostics/active.vsg")
                        menuItem("Popular issues", "/app/project/${this@MProjectRootScene.props.projectId}/diagnostics/popular.vsg")
                    }
                }
                footer {
                    menuItem("Settings", "settings", "/app/project/${this@MProjectRootScene.props.projectId}/settings.vsg")
                    menuItem("Logout", "logout", "/app/logout.vsg")
                }
            }

            Router {
                route("/app/project/{projectId}/index.vsg") {
                    Page {
                        head("Dashboard")
                        body {
                            + "Coming soon..."
                        }
                    }
                }

                // analytics
                route("/app/project/{projectId}/analytics/players.vsg") {
                    AnalyticsDashboardScene(AnalyticsDashboardSceneProps(this@MProjectRootScene.props.projectId))
                }
                route("/app/project/{projectId}/analytics/newPlayers.vsg") {
                    CustomStatScene(
                        CustomStatSceneProps(
                            this@MProjectRootScene.props.projectId,
                            "NewUsers",
                            "NewPlayers",
                            "",
                            "",
                            1,
                            1
                        )
                    )
                }
                route("/app/project/{projectId}/analytics/revenue.vsg") {
                    CustomStatScene(
                        CustomStatSceneProps(
                            this@MProjectRootScene.props.projectId,
                            "_REVENUE_",
                            "Revenue",
                            "$",
                            "",
                            1,
                            100
                        )
                    )
                }
                route("/app/project/{projectId}/analytics/trialUsers.vsg") {
                    CustomStatScene(
                        CustomStatSceneProps(
                            this@MProjectRootScene.props.projectId,
                            "TrialUsers",
                            "Trial Users",
                            "",
                            "",
                            1,
                            1
                        )
                    )
                }
                route("/app/project/{projectId}/analytics/platforms.vsg") {
                    CustomStatScene(
                        CustomStatSceneProps(
                            this@MProjectRootScene.props.projectId,
                            "Platforms",
                            "Platforms",
                            "",
                            "",
                            1,
                            1
                        )
                    )
                }
                route("/app/project/{projectId}/analytics/activity.vsg") {
                    CustomStatScene(
                        CustomStatSceneProps(
                            this@MProjectRootScene.props.projectId,
                            "Activity",
                            "Activity",
                            "",
                            "m",
                            60,
                            60,
                            "h "
                        )
                    )
                }

                // players
                route("/app/project/{projectId}/players/browse.vsg") {
                    PlayersListScene(PlayersListSceneProps(this@MProjectRootScene.props.projectId))
                }
                route("/app/project/{projectId}/players/config.vsg") {
                    PlayerConfigScene(this@MProjectRootScene.props.projectId)
                }
                route("/app/project/{projectId}/player/{playerId}/index.vsg") {
                    val playerId = params["playerId"]!!.toString()
                    PlayerSceneScene(PlayerSceneProps(this@MProjectRootScene.props.projectId, playerId))
                }
                route("/app/project/{projectId}/leaderboards/index.vsg") {
                    LeaderboardListScene(LeaderboardListSceneProps(this@MProjectRootScene.props.projectId))
                }

                route("/app/project/{projectId}/remoteConfig.vsg") {
                    RemoteConfigScene(this@MProjectRootScene.props.projectId)
                }
                route("/app/project/{projectId}/allowedVersions.vsg") {
                    AllowedVersionsScene(AllowedVersionsSceneProps(this@MProjectRootScene.props.projectId))
                }
                route("/app/project/{projectId}/userReports.vsg") {
                    UserReportsScene(UserReportsSceneProps(this@MProjectRootScene.props.projectId))
                }
                route("/app/project/{projectId}/settings.vsg") {
                    SettingsScene(this@MProjectRootScene.props.projectId)
                }

                // diagnostics
                route("/app/project/{projectId}/diagnostics/new.vsg") {
                    DiagnosticsErrorGroupsScene("New Issues", DiagnosticsErrorGroupsSceneProps(this@MProjectRootScene.props.projectId, "-firstSeenAt"))
                }
                route("/app/project/{projectId}/diagnostics/active.vsg") {
                    DiagnosticsErrorGroupsScene("Active Issues", DiagnosticsErrorGroupsSceneProps(this@MProjectRootScene.props.projectId, "-lastSeenAt"))
                }
                route("/app/project/{projectId}/diagnostics/popular.vsg") {
                    DiagnosticsErrorGroupsScene("Popular Issues", DiagnosticsErrorGroupsSceneProps(this@MProjectRootScene.props.projectId, "-issueCount"))
                }
                route("/app/project/{projectId}/diagnostics/{groupId}/issues.vsg") {
                    val groupId = params["groupId"]!!.toString()
                    DiagnosticsIssueListScene(DiagnosticsIssueListSceneProps(this@MProjectRootScene.props.projectId, groupId))
                }

            }
        }
    }
}

class ProjectRootSceneState {

}

fun Components.ProjectRootScene(props: ProjectRootSceneProps) = this.registerComponent(MProjectRootScene(props), {})
